import React, { useState, useEffect, useRef } from "react";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import ReportsDiamondService from "../../../services/reports-Diamond.service";
import GlobalDiamondReportService from "../../../services/reports-globalDiamond-service";
import logoImg from "../../../assets/images/logo-img.png";
import { useSelector } from "react-redux";
import moment from "moment";
import { BlobToDownloadFile } from "../../../helper/commanFunction";
import { Button, DatePicker, Spin, Table, Tooltip } from "antd";
import Chart from "react-google-charts";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const { RangePicker } = DatePicker;

const DiamondVendorBasedAddToCartReport = () => {
  const { t } = useTranslation();
  const DiamondCutChartRef = useRef();
  
  /*Initial State for Binding Starts*/
  const initialGlobalDiamondState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
  };
  /*Initial State for Binding Ends*/
  
  /*React Binding Starts*/
  const [TableForAllList, setTableForAllList] = useState([]);
  const [globalDiamonds, setGlobalDiamond] = useState(initialGlobalDiamondState);
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [TableForAllLoading, setTableForAllLoading] = useState(false);
  const [TotalDiamondClicks, setTotalDiamondClicks] = useState(0);
  const [dealerId, setDealerId] = useState();
  const [forDealer, setForDealer] = useState("");
  const loginDetials = useSelector((state) => state.loginReducer);
  const [diamondCutGradeSearchesLabels, setdiamondCutGradeSearchesLabels] = useState([]);
  const [DiamondCutGradeSearchesList, setDiamondCutGradeSearchesList] = useState([]);
  const [DiamondCutGradeColorData, setDiamondCutGradeColorData] = useState([]);
  const [DiamondCutGradeYAxisList, setDiamondCutGradeYAxisList] = useState([]);
  const [TableCutGradeValue, setTableCutGradeValue] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [sortType, setSortType] = useState("desc");
  const [sortColumnName, setSortColumnName] = useState("AK.Date");
  const [key, setKey] = useState(true);
  const [downloadCSVDataloading, setDownloadCSVDataloading] = useState(false);

  // New state for custom legends and max entries
  const [chartData, setChartData] = useState([]);
  const [colorData, setColorData] = useState([]);
  const [processedVendorLabels, setProcessedVendorLabels] = useState([]);
  const [processedVendorCounts, setProcessedVendorCounts] = useState([]);

  // Configuration
  const MAX_ENTRIES = 15; // Maximum bars to show
  const chartColors = [
    "#0EDCE8", "#109618", "#FF9900", "#990099", "#0099C6",
    "#3366CC", "#DC3912", "#66AA00", "#DD4477", "#EDED01",
    "#B82E2E", "#316395", "#994499", "#22AA99", "#AAAA11",
    "#6633CC", "#E67300", "#8B0707", "#329262", "#3B3EAC"
  ];

  /*React Binding Ends*/

  // Process chart data with max entries limit for bar chart
  const processChartData = (vendors, counts) => {
    if (!vendors?.length || !counts?.length || vendors.length !== counts.length) {
      return { chartData: [], colors: [], processedLabels: [], processedCounts: [] };
    }

    // Combine vendors and counts into objects
    const combinedData = vendors.map((vendor, index) => ({
      vendor,
      count: counts[index],
      originalIndex: index
    }));

    // Filter out zero values and sort by count (descending)
    const filteredData = combinedData.filter(item => item.count > 0);
    const sortedData = [...filteredData].sort((a, b) => b.count - a.count);

    // Apply max entries limit
    const topData = sortedData.slice(0, MAX_ENTRIES);
    const remainingData = sortedData.slice(MAX_ENTRIES);

    // Calculate "Others" if needed
    const othersValue = remainingData.reduce((sum, item) => sum + item.count, 0);
    if (othersValue > 0 && remainingData.length > 0) {
      topData.push({
        vendor: t("Others"),
        count: othersValue,
        isOthers: true
      });
    }

    // Prepare chart data
    const processedChartData = [["Vendor", "Count", { role: "style" }]];
    const colors = [];
    const processedLabels = [];
    const processedCounts = [];

    topData.forEach((item, index) => {
      const color = chartColors[index % chartColors.length];
      colors.push(color);
      
      // For Google Charts with style
      processedChartData.push([item.vendor, item.count, `color: ${color}`]);
      
      // Store processed data for other uses
      processedLabels.push(item.vendor);
      processedCounts.push(item.count);
    });

    return { 
      chartData: processedChartData, 
      colors, 
      processedLabels, 
      processedCounts 
    };
  };

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleCheckDealermembers(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
  }, []);

  useEffect(() => {
    if (TableCutGradeValue) {
      handleGetDiamondReportForTableChartAll(
        dealerId,
        forDealer,
        1,
        15,
        "AK.Date",
        "asc"
      );
      setSortColumnName("AK.Date");
      setSortType("desc");
      setPageNo(1);
      setPageSize(15);
    }
  }, [TableCutGradeValue]);

  /*API Binding Starts*/
  const handleCheckDealermembers = (id) => {
    try {
      let inputData = {
        dealerID: id,
      };

      GlobalDiamondReportService.CheckDealermembers(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;

          // Calculate forDealer based on dealerMemberTypeName
          let forDealer;
          if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "VendorDiamond" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
          ) {
            forDealer = 1;
          } else if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "Retailer" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Combined"
          ) {
            forDealer = 2;
          } else {
            forDealer = 3;
          }

          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setForDealer(forDealer);
            } else {
              setForDealer("");
            }
            handleLoadChartReports(id, forDealer);
            handleGetDiamondReportForTableChartAll(
              id,
              forDealer,
              pageNo,
              pageSize,
              sortColumnName,
              sortType
            );
          } else {
            setForDealer("");
          }
        })
        .catch((error) => {
          setForDealer("");
        });
    } catch (error) {
      setForDealer("");
    }
  };

  const handleLoadChartReports = (dealerId, forDealer) => {
    try {
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "VendorDiamond"
      ) {
        forDealer = 1;
      }
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer.toString(),
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2016-03-07",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2023-04-06",
        selectedDiamondValue: "All",
        addToType: "AddToCart",
      };
      setLoadChartReportsLoading(true);

      ReportsDiamondService.AddToCartOrWishlistChartColunmData(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var DiamondCutGradeSearchesList = responseData.VendorBasedData;
          var TotalDiamondClicks =
            responseData.TotalDiamondClicks[0].TotalClickCnt;
          setLoadChartReportsLoading(false);
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setTotalDiamondClicks(TotalDiamondClicks);
              setDiamondCutGradeSearchesList(DiamondCutGradeSearchesList);
              var DiamondCutGradeSearchesLabelArr =
                DiamondCutGradeSearchesList.map((item) => {
                  return item.VendorName;
                });
              setdiamondCutGradeSearchesLabels(DiamondCutGradeSearchesLabelArr);
              var DiamondCutGradeYAxisList = DiamondCutGradeSearchesList.map(
                (item) => {
                  return item.CNT;
                }
              );
              var DiamondCutGradeColorList = DiamondCutGradeSearchesList.map(
                (item) => {
                  return item.VendorName;
                }
              );
              setDiamondCutGradeYAxisList(DiamondCutGradeYAxisList);
              
              // Process data with max entries limit
              const { 
                chartData: processedChartData, 
                colors, 
                processedLabels, 
                processedCounts 
              } = processChartData(DiamondCutGradeSearchesLabelArr, DiamondCutGradeYAxisList);
              
              setChartData(processedChartData);
              setColorData(colors);
              setProcessedVendorLabels(processedLabels);
              setProcessedVendorCounts(processedCounts);
              
              diamondCutGradeColorHandler(DiamondCutGradeColorList);
              setKey(!key);
            }
          } else {
            setTotalCount(0);
            setDiamondCutGradeSearchesList([]);
            setDiamondCutGradeYAxisList([]);
            setChartData([]);
            setColorData([]);
          }
        })
        .catch((error) => {
          setTotalCount(0);
          setDiamondCutGradeSearchesList([]);
          setDiamondCutGradeYAxisList([]);
          setLoadChartReportsLoading(false);
          setdiamondCutGradeSearchesLabels([]);
          setChartData([]);
          setColorData([]);
        });
    } catch (error) {
      setTotalCount(0);
      setDiamondCutGradeSearchesList([]);
      setDiamondCutGradeYAxisList([]);
      setLoadChartReportsLoading(false);
      setdiamondCutGradeSearchesLabels([]);
      setChartData([]);
      setColorData([]);
    }
  };

  const handleExportToCSV = (sortColumn, sorttype) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2016-03-12",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2023-04-11",
        clarity: "",
        cutGrade: "",
        shape: "",
        color: "",
        size: "",
        certificate: "",
        selectedDiamondValue: "All",
        pageNumber: globalDiamonds.pageNumber
          ? globalDiamonds.pageNumber
          : pageNo,
        pageSize: globalDiamonds.pageSiz ? globalDiamonds.pageSiz : pageNo,
        sortOrderCol: sortColumn ? sortColumn : sortColumnName,
        sortOrderType: sorttype ? sorttype : sortType,
        addToType: "AddToCart",
        price: "",
        price1: "",
        price2: "",
        vendorIds: TableCutGradeValue ? TableCutGradeValue.toString() : "",
      };
      setDownloadCSVDataloading(true);
      ReportsDiamondService.ExportDataToCSV(inputData)
        .then((response) => {
          setDownloadCSVDataloading(false);
          var fileName =
            loginDetials.loginDetials.responseData.dealerCompany.replace(/\s+/g, "") +
            "_DiamondVendor_Report_" +
            new Date().toJSON().slice(0, 10).split("-").slice(1).concat(new Date().toJSON().slice(0, 4)).join("_") +
            ".csv";
          BlobToDownloadFile(response.data, fileName);
        })
        .catch((error) => {
          setDownloadCSVDataloading(false);
        });
    } catch (error) {
      setDownloadCSVDataloading(false);
    }
  };

  const handleGetDiamondReportForTableChartAll = (
    dealerId,
    forDealer,
    pageNumber,
    pageSiz,
    sortColumn,
    sorttype
  ) => {
    try {
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "VendorDiamond"
      ) {
        forDealer = 1;
      }
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2016-03-12",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2023-04-11",
        clarity: "",
        cutGrade: "",
        shape: "",
        color: "",
        size: "",
        certificate: "",
        selectedDiamondValue: "All",
        pageNumber: pageNumber ? pageNumber : pageNo,
        pageSize: pageSiz ? pageSiz : pageNo,
        sortOrderCol: sortColumn ? sortColumn : sortColumnName,
        sortOrderType: sorttype ? sorttype : sortType,
        addToType: "AddToCart",
        price: "",
        price1: "",
        price2: "",
        vendorIds: TableCutGradeValue ? TableCutGradeValue.toString() : "",
      };

      setTableForAllLoading(true);

      ReportsDiamondService.AddToCartOrWishlistReportForTableChart(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var TableForAllList = responseData.tableChartList;
          var TotalEventsCount = responseData.totalCount;
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setTotalCount(TotalEventsCount);
              setTableForAllList(TableForAllList);
              setTableForAllLoading(false);
            }
          } else {
            setTotalCount(0);
            setTableForAllList([]);
            setTableForAllLoading(false);
          }
        })
        .catch((error) => {
          setTotalCount(0);
          setTableForAllList([]);
          setTableForAllLoading(false);
        });
    } catch (error) {
      setTotalCount(0);
      setTableForAllList([]);
      setTableForAllLoading(false);
    }
  };

  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";

    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "DESC";
      column = "AK.Date";
      setSortColumnName(column);
      setSortType(type);
    }
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    handleGetDiamondReportForTableChartAll(
      dealerId,
      forDealer,
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };
  /*API Binding Ends*/

  const diamondCutGradeColorHandler = (list) => {
    const color = [];
    for (let i = 0; i < list.length; i++) {
      color.push("rgb(66, 133, 244)");
    }
    setDiamondCutGradeColorData(color);
  };

  /*DatePicker Binding Starts*/
  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalDiamond((prevState) => ({
        ...prevState,
        dataRangeFrom: moment.utc(dateStrings[0]).toISOString(),
        dataRangeTo: moment.utc(dateStrings[1]).toISOString(),
      }));
    }
  };
  /*DatePicker Binding Ends*/

  const handleApplyFilter = () => {
    handleLoadChartReports(dealerId, forDealer);
    handleGetDiamondReportForTableChartAll(
      dealerId,
      forDealer,
      1,
      15,
      sortColumnName,
      sortType
    );
  };

  const chartOptions = {
    legend: { position: "none" },
    chartArea: { width: "80%", height: "80%" },
    hAxis: {
      title: "",
      slantedText: true,
      slantedTextAngle: 45,
    },
    vAxis: {
      title: "",
    },
    bar: { groupWidth: "70%" },
  };

  const handleSelect = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      const label = chartData[selectedItem.row + 1][0];
      
      // Handle "Others" selection
      if (label === t("Others")) {
        // You might want to handle "Others" selection differently
        // For now, let's clear the vendor filter when "Others" is selected
        setTableCutGradeValue("");
        return;
      }
      
      setTableCutGradeValue(label);
    }
  };

  const handleDownloadBarChart = () => {
    const element = document?.getElementById("pdf-content-bar-chart");

    setTimeout(() => {
      html2canvas(element, { 
        useCORS: true,
        scale: 3 
      }).then((canvas) => {
        const imgData = canvas?.toDataURL("image/png");

        const pdf = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: "a4",
        });

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // --- HEADER BACKGROUND ---
        pdf.setFillColor(31, 38, 62);
        pdf.rect(0, 0, pageWidth, 20, "F");

        // Add logo (left side)
        const logoWidth = 55;
        const logoHeight = 13;
        pdf.addImage(logoImg, "PNG", 10, 5, logoWidth, logoHeight);

        // Report title (right side)
        pdf
          .setFontSize(16)
          .setFont(undefined, "bold")
          .setTextColor(255, 255, 255);
        pdf.text("DIAMOND VENDOR ADD TO CART REPORT", pageWidth - 10, 12, {
          align: "right",
        });

        // --- DETAILS ---
        const detailsY = 25;
        pdf.setFontSize(10).setFont(undefined, "normal").setTextColor('black');
        if (loginDetials.impresonateData) {
          pdf.text(
            `Prepared For : ${loginDetials.impresonateData.username} (${loginDetials.impresonateData.dealerID})`,
            20,
            detailsY
          );
        } else {
          pdf.text(
            `Prepared For : ${loginDetials.loginDetials.responseData.dealerCompany} (${loginDetials.loginDetials.responseData.dealerId})`,
            20,
            detailsY
          );
        }
        pdf
          .setFontSize(10)
          .setFont(undefined, "normal")
          .setTextColor(102, 102, 102);
        
        pdf.text(
          `Date Range: ${moment(globalDiamonds.dataRangeFrom).format(
            "MMM DD, YYYY"
          )} - ${moment(globalDiamonds.dataRangeTo).format("MMM DD, YYYY")}`,
          20,
          detailsY + 5
        );
        pdf.text(
          `Selected Diamond: All Diamonds`,
          20,
          detailsY + 10
        );
        pdf.setFont(undefined, "bold").setTextColor(66, 133, 244);
        pdf.text(
          `Total Clicks: ${TotalDiamondClicks ? TotalDiamondClicks.toLocaleString() : 0}`,
          20,
          detailsY + 15
        );

        // --- CHART ---
        const imgWidth = 220;
        const imgProps = { width: canvas.width, height: canvas.height };
        const ratio = imgProps.width / imgProps.height;
        const pdfHeight = imgWidth / ratio;
        const xPos = (pageWidth - imgWidth) / 2;
        const yPos = (pageHeight - pdfHeight) / 2 + 5;
        pdf.addImage(imgData, "PNG", xPos, yPos, imgWidth, pdfHeight);

        // --- FOOTER BACKGROUND ---
        pdf.setFillColor(31, 38, 62);
        pdf.rect(0, pageHeight - 20, pageWidth, 20, "F");

        // Grey border (end-to-end)
        pdf.setDrawColor(200, 200, 200);
        pdf.line(0, pageHeight - 20, pageWidth, pageHeight - 20);

        // Footer text
        pdf
          .setFontSize(9)
          .setTextColor(255, 255, 255)
          .setFont(undefined, "italic");
        const footerText = `© ${new Date().getFullYear()} JewelCloud Inc. | Generated on ${moment().format(
          "MMMM DD, YYYY h:mm A"
        )}`;
        pdf.text(footerText, pageWidth / 2, pageHeight - 10, {
          align: "center",
        });

        // --- PAGE NUMBERS ---
        const pageCount = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
          pdf.setPage(i);
          pdf.setFontSize(8).setTextColor(0, 0, 0);
          pdf.text(
            `Page ${i} of ${pageCount}`,
            pageWidth - 10,
            pageHeight - 5,
            {
              align: "right",
            }
          );
        }

        // --- WATERMARK ---
        const watermarkText = "JewelCloud";
        pdf.setFontSize(90);
        pdf.setFont(undefined, "bolditalic");
        pdf.setTextColor(102, 102, 102);

        pdf.saveGraphicsState();
        pdf.setGState(pdf.GState({ opacity: 0.1 }));

        const centerX = pageWidth / 2;
        const centerY = pageHeight / 2;

        const textWidth = pdf.getTextWidth(watermarkText);
        const textHeight =
          pdf.internal.getFontSize() / pdf.internal.scaleFactor;

        const angleRad = (45 * Math.PI) / 180;
        const rotatedWidth =
          textWidth * Math.cos(angleRad) + textHeight * Math.sin(angleRad);
        const rotatedHeight =
          textWidth * Math.sin(angleRad) + textHeight * Math.cos(angleRad);

        const xPosWatermark = centerX - rotatedWidth / 2;
        const yPosWatermark = centerY + rotatedHeight / 4 + 40;

        pdf.text(watermarkText, xPosWatermark, yPosWatermark, { angle: 45 });

        pdf.restoreGraphicsState();

        // --- SAVE ---
        pdf.save("Diamond-Vendor-AddToCart-Report.pdf");
      });
    }, 1000);
  };

  return (
    <React.Fragment>
      <div className="form__fields magento__mapping">
        <div className="row">
          <div className="col-lg-12">
            <div className="heading__block">
              <h4 class="workarea__heading mt-0 mb-0">
                {t("Diamond Vendor based Add To Cart Report")}
              </h4>
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block dataRange-input-block datepicker__block">
              <label> {t("Date Range")} </label>
              <RangePicker
                className="date-range-input"
                ranges={{
                  Today: [moment(), moment()],
                  Yesterday: [
                    moment().subtract(1, "days"),
                    moment().subtract(1, "days"),
                  ],
                  "Last 7 Days": [moment().subtract(7, "days"), moment()],
                  "Last 30 Days": [moment().subtract(30, "days"), moment()],
                  "This Month": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Last Month": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "months").endOf("month"),
                  ],
                  "Last 90 Days": [moment().subtract(90, "days"), moment()],
                  "Year To Date": [moment().startOf("year"), moment()],
                }}
                format={"MM-DD-YYYY"}
                onChange={onDateChange}
                defaultValue={[moment().subtract(30, "days"), moment()]}
                defaultPickerValue={[moment().subtract(30, "days"), moment()]}
              />
            </div>
          </div>
          {TableForAllList &&
            TableForAllList.length > 0 &&
            DiamondCutGradeSearchesList.length > 0 && (
              <div className="col-lg-12 col-md-6">
                <div className="input__block">
                  <label>
                    <Spin spinning={LoadChartReportsLoading} size="small">
                      <b>
                        {" "}
                        {t("Total Clicks")} :{" "}
                        {TotalDiamondClicks ? TotalDiamondClicks : 0}
                      </b>
                    </Spin>
                  </label>
                </div>
              </div>
            )}

          <div className="col-md-12 mt-2">
            <div className="button__block mb-4">
              <button className="primary-btn mr-2" onClick={handleApplyFilter}>
                {" "}
                {t("Apply Filter")}{" "}
              </button>
            </div>
          </div>
          <div className="chart__section">
            <Spin spinning={LoadChartReportsLoading} size="large">
              {TableForAllList && TableForAllList.length > 0 && chartData.length > 1 ? (
                <div id="pdf-content-bar-chart">
                  {/* Custom Legend for Bar Chart */}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      marginBottom: "15px",
                      gap: "8px",
                    }}
                  >
                    {chartData.slice(1).map((row, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          margin: "2px 4px",
                          fontSize: "12px",
                          fontWeight: "500",
                          padding: "4px 8px",
                          backgroundColor: "#f5f5f5",
                          borderRadius: "4px",
                          border: `2px solid ${colorData[index]}`,
                        }}
                      >
                        <div
                          style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: colorData[index],
                            marginRight: "6px",
                            borderRadius: "2px",
                          }}
                        ></div>
                        {row[0]} ({row[1]})
                      </div>
                    ))}
                  </div>

                  {/* Bar Chart */}
                  <div className="pdf-content-bar-chart">
                    <Chart
                      chartType="ColumnChart"
                      width={window.innerWidth > 500 ? "100%" : 300}
                      height={window.innerWidth > 500 ? 500 : 300}
                      data={chartData}
                      options={chartOptions}
                      chartEvents={[
                        {
                          eventName: "select",
                          callback: handleSelect,
                        },
                      ]}
                    />
                  </div>
                </div>
              ) : (
                <div className="no-report-render">
                  <div className="desc-space">
                    <h4 className="text-center">{t("No Data Found")}</h4>
                  </div>
                </div>
              )}
            </Spin>
          </div>

          {TableForAllList?.length > 0 && chartData.length > 1 && (
            <div className="col-md-12 mt-2">
              <div className="button__block mb-4">
                <button
                  className="primary-btn mr-2"
                  onClick={handleDownloadBarChart}
                >
                  {" "}
                  {t("Download Chart")}{" "}
                </button>
              </div>
            </div>
          )}

          <div className="col-lg-12 mt-3">
            <div className="options__div">
              <div className="row mb-4">
                <div className="col-lg-10 rules__div"></div>
                <div className="col-lg-2 crud__div text-end">
                  <Button
                    className="primary-btn"
                    onClick={() => handleExportToCSV()}
                    loading={downloadCSVDataloading}
                  >
                    {" "}
                    <i className="fa fa-download"></i> {t("Download CSV")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12 col-md-12">
            <Table
              className="pendjewelreq__tbl"
                scroll={{ x: 1200, y: "calc(100vh - 340px)" }}
              loading={TableForAllLoading}
              columns={[
                {
                  title: (
                    <Tooltip title={t("UserIPAddress")}>
                      {t("UserIPAddress")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "usersIPAddress",
                  sorter: (a, b) => {},
                },
                {
                  title: <Tooltip title={t("Date")}>{t("Date")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "date",
                  defaultSortOrder: "descend",
                  sorter: (a, b) => {},
                  render: (item, row) => {
                    return moment(row.date).format("MM-DD-YYYY, hh:mm:ss A");
                  },
                },
                {
                  title: <Tooltip title={t("Shape")}>{t("Shape")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "shape",
                  sorter: (a, b) => {},
                },
                {
                  title: <Tooltip title={t("Size")}>{t("Size")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "size",
                  sorter: (a, b) => {},
                },
                {
                  title: <Tooltip title={t("Color")}>{t("Color")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "color",
                  sorter: (a, b) => {},
                },
                {
                  title: <Tooltip title={t("Cut")}>{t("Cut")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "cutGrade",
                  sorter: (a, b) => {},
                },

                {
                  title: <Tooltip title={t("Clarity")}>{t("Clarity")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "clarity",
                  sorter: (a, b) => {},
                },
                {
                  title: (
                    <Tooltip title={t("Certificate")}>
                      {t("Certificate")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "certificate",
                  sorter: (a, b) => {},
                },
                {
                  title: (
                    <Tooltip title={t("Retail Price")}>
                      {t("Retail Price")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "retailPrice",
                  sorter: (a, b) => {},
                  render: (retailPrice) => (
                    <Tooltip title={retailPrice}>
                      <span>{retailPrice}</span>
                    </Tooltip>
                  ),
                },
                {
                  title: <Tooltip title={t("Cost")}>{t("Cost")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "cost",
                  sorter: (a, b) => {},
                  render: (cost) => (
                    <Tooltip title={cost}>
                      <span>{cost}</span>
                    </Tooltip>
                  ),
                },
              ]}
              dataSource={TableForAllList}
              pagination={{
                size: "small",
                total: totalCount,
                pageNo: pageNo,
                pageSize: pageSize,
                pageSizeOptions: [10, 15, 20, 50, 100],
                responsive: true,
                showSizeChanger: true,
              }}
              onChange={handleTableASCDES}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondVendorBasedAddToCartReport;